export enum AsyncComponentUserEnum {
    UserMutate = 'UserMutate',
    UserList = 'UserList',

}

export const userComponents = {
    [ AsyncComponentUserEnum.UserMutate ]: () => import( '@/views/user/userMutate/UserMutate.vue' ),
    [ AsyncComponentUserEnum.UserList ]: () => import( '@/views/user/userList/UserList.vue' ),
}
